/**
 * config/colleges.js
 * ==================
 * 단과대학과 그 아래 학과 목록.
 *
 * 회원가입에서 단과대를 고르면 학과 선택지가 여기 정의된 것만 남는다.
 * 값은 그대로 DB 의 User.college / User.major 에 문자열로 저장되므로,
 * 학과 이름을 바꾸면 그 뒤로 가입하는 사람만 새 이름으로 들어간다
 * (기존 회원 데이터는 바뀌지 않는다).
 *
 * 학과가 개편되면 이 파일만 고치면 된다.
 */

export const COLLEGES = [
    {
        name: "인문대학",
        majors: [
            "국어국문학과",
            "영어영문학과",
            "독일어문학전공",
            "프랑스어문학전공",
            "러시아어문학전공",
            "중국어문학전공",
            "일본어문학전공",
            "철학과",
            "역사학과",
        ],
    },
    {
        name: "사회과학대학",
        majors: [
            "정치국제학과",
            "공공인재학부",
            "심리학과",
            "문헌정보학과",
            "사회복지학부",
            "미디어커뮤니케이션학부",
            "도시계획부동산학과",
            "사회학과",
        ],
    },
    {
        name: "사범대학",
        majors: ["교육학과", "유아교육과", "영어교육과", "체육교육과"],
    },
    {
        name: "자연과학대학",
        majors: ["물리학과", "화학과", "생명과학과", "수학과"],
    },
    {
        name: "공과대학",
        majors: [
            "건설환경플랜트공학과",
            "도시시스템공학과",
            "건축학부",
            "화학공학과",
            "기계공학부",
            "에너지시스템공학부",
            "첨단소재공학과",
        ],
    },
    {
        name: "창의ICT공과대학",
        majors: ["전자전기공학부", "융합공학부", "지능형반도체학과"],
    },
    {
        name: "소프트웨어대학",
        majors: ["소프트웨어학부", "AI학과"],
    },
    {
        name: "경영경제대학",
        majors: [
            "경영학부",
            "글로벌금융전공",
            "경제학부",
            "응용통계학과",
            "광고홍보학과",
            "지식경영학부",
            "국제물류학과",
            "산업보안학과",
        ],
    },
    {
        name: "의과대학",
        majors: ["의학부"],
    },
    {
        name: "약학대학",
        majors: ["약학부"],
    },
    {
        name: "간호대학",
        majors: ["간호학과"],
    },
    {
        name: "예술대학",
        majors: ["연극전공", "영화전공", "공간연출전공"],
    },
];

/**
 * 학과 개편으로 없어진 학과 출신을 위한 선택지.
 *
 * 기존 회원 재활성화에서 학과를 필수로 받는데, 졸업생 중에는 재학 당시
 * 학과가 위 목록에 없는 사람이 있다. 이 선택지가 없으면 그 사람들은
 * 계정을 되찾을 수 없다. 신규 가입 화면에도 함께 노출되지만 재학생이
 * 고를 이유가 없다.
 */
export const LEGACY_MAJOR = "기타/폐과 학과";

/** 단과대 이름 -> 학과 목록. 없는 이름이면 빈 배열. */
export const majorsOf = (collegeName) => {
    const found = COLLEGES.find((college) => college.name === collegeName);
    return found ? [...found.majors, LEGACY_MAJOR] : [];
};

/** 그 단과대에 실제로 있는 학과인지 (단과대를 바꿨을 때 학과를 비울지 판단) */
export const hasMajor = (collegeName, majorName) =>
    majorsOf(collegeName).includes(majorName);
